import React from "react";
import { useCart } from "../../../context/CartContext";
import { useTranslation } from "../../../context/TranslationsProvider";
import { Link, useParams } from "react-router-dom";

const CartDropdown: React.FC = () => {
    const { cart, removeFromCart } = useCart();
    const { translate } = useTranslation();

    return (
        <div className="absolute top-10 right-0 w-80 bg-white shadow-lg rounded-lg p-4 z-50">
            <h2 className="text-lg font-bold border-b pb-2">{translate("cart_name")}</h2>

            {cart.length === 0 ? (
                <p className="text-center py-4">{translate("cart_empty")}</p>
            ) : (
                <div className="max-h-60 overflow-y-auto">
                    {cart.map((item, index) => (
                        <Link
                            to={`/painting/${item.title}`}
                            key={item.id}
                            className={`flex items-center justify-between border-b pb-2 mb-2 ${index === 0 ? 'pt-2' : ''} hover:bg-gray-100 p-2 transition-colors`}
                        >
                            <div className="flex items-center flex-1">
                                <img src={item.image} alt={item.title} className="w-12 h-12 object-cover mr-2"/>

                                <div className="flex flex-col max-w-[140px]">
                                    <p className="text-sm font-semibold overflow-hidden whitespace-nowrap text-ellipsis">
                                        {item.title}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        {item.price}€ | {item.dimensions}
                                    </p>
                                </div>
                            </div>

                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removeFromCart(item.id);
                                }}
                                className="text-black text-lg p-2 rounded-full hover:bg-gray-200"
                            >
                                <svg className="fill-gray-800 h-4 w-4" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z" fillRule="evenodd"></path>
                                    </g>
                                </svg>
                            </button>
                        </Link>
                    ))}
                </div>
            )}

            <Link
                to="/cart"
                className="block text-center px-4 py-1.5 rounded-md bg-black text-orange-100"
            >
                {translate("cart_view")}
            </Link>
        </div>
    );
};

export default CartDropdown;